// // src/pages/LogSphere.js
// import React, { useEffect, useState, useRef } from 'react';
// import { Link } from 'react-router-dom';
// import { Helmet } from 'react-helmet';
// import Navbar from '../components/Navbar';
// import Footer from '../components/Footer';
// import imagesLoaded from 'imagesloaded';
// import './OneStepMedi.css';

// const API_URL = 'https://api.securxperts.com:8000';
// const ENDPOINT = '/forms/contact';

// /* -------------------- CONTACT FORM ----------------------- */
// const ContactForm = () => {
//   const [form, setForm] = useState({
//     name: '',
//     email: '',
//     country_code: '',
//     phoneno: '',
//     location: '',
//     purpose: '',
//     message: '',
//   });

//   const [submitting, setSubmitting] = useState(false);
//   const [status, setStatus] = useState(null);

//   const handleChange = (e) =>
//     setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

//   const validate = () => {
//     if (!form.name.trim()) return 'Name is required';
//     if (!form.email.trim()) return 'Email is required';
//     const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!emailRe.test(form.email)) return 'Enter a valid email';
//     if (!form.country_code.trim()) return 'Country code is required';
//     if (!form.phoneno.trim()) return 'Phone number is required';
//     if (!form.location.trim()) return 'Location is required';
//     if (!form.purpose.trim()) return 'Purpose is required';
//     if (!form.message.trim()) return 'Message is required';
//     return null;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setStatus(null);

//     const err = validate();
//     if (err) {
//       setStatus({ type: 'error', msg: err });
//       return;
//     }

//     setSubmitting(true);
//     try {
//       const payload = { ...form };

//       const resp = await fetch(`${API_URL}${ENDPOINT}`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(payload),
//       });

//       if (resp.ok) {
//         let data = null;
//         try {
//           data = await resp.json();
//         } catch {
//           // ignore parse errors
//         }
//         setStatus({
//           type: 'success',
//           msg: data?.message || 'Thank you! Your request has been submitted.',
//         });
//         setForm({
//           name: '',
//           email: '',
//           country_code: '',
//           phoneno: '',
//           location: '',
//           purpose: '',
//           message: '',
//         });
//       } else {
//         let errText = `Server responded with ${resp.status}`;
//         try {
//           const json = await resp.json();
//           if (json?.error) errText = json.error;
//           else if (json?.message) errText = json.message;
//         } catch {
//           const txt = await resp.text().catch(() => null);
//           if (txt) errText = txt;
//         }
//         setStatus({ type: 'error', msg: `Submission failed: ${errText}` });
//       }
//     } catch (error) {
//       console.error('LogSphere contact submit error:', error);
//       setStatus({ type: 'error', msg: 'Network error. Please try again.' });
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <form
//       onSubmit={handleSubmit}
//       className="max-w-3xl mx-auto bg-white/5 p-6 md:p-10 rounded-2xl shadow-lg"
//       aria-label="LogSphere Enquiry Form"
//     >
//       <h3 className="text-2xl md:text-3xl font-bold text-center mb-6 text-white">
//         Talk to Our LogSphere Experts
//       </h3>

//       <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//         <input
//           name="name"
//           value={form.name}
//           onChange={handleChange}
//           placeholder="Full Name"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />

//         <input
//           name="email"
//           type="email"
//           value={form.email}
//           onChange={handleChange}
//           placeholder="Email"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />

//         <input
//           name="country_code"
//           value={form.country_code}
//           onChange={handleChange}
//           placeholder="Country Code (e.g. +91)"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />

//         <input
//           name="phoneno"
//           value={form.phoneno}
//           onChange={handleChange}
//           placeholder="Phone Number"
//           type="tel"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />

//         <input
//           name="location"
//           value={form.location}
//           onChange={handleChange}
//           placeholder="Location (City, Country)"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none md:col-span-2"
//         />

//         <input
//           name="purpose"
//           value={form.purpose}
//           onChange={handleChange}
//           placeholder="Purpose (Demo / Partnership / Implementation)"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none md:col-span-2"
//         />

//         <textarea
//           name="message"
//           value={form.message}
//           onChange={handleChange}
//           placeholder="Tell us briefly about your recruitment / onboarding needs"
//           rows={4}
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none md:col-span-2 resize-none"
//         />
//       </div>

//       <button
//         type="submit"
//         disabled={submitting}
//         className="bg-blue-600 hover:bg-blue-700 transition px-6 py-3 rounded-full font-semibold w-full mt-6 disabled:opacity-50"
//       >
//         {submitting ? 'Submitting...' : 'Submit'}
//       </button>

//       {status && (
//         <p
//           role="status"
//           className={`text-center mt-4 text-sm ${
//             status.type === 'success' ? 'text-green-400' : 'text-red-400'
//           }`}
//         >
//           {status.msg}
//         </p>
//       )}

//       <p className="text-xs mt-4 text-white/60 text-center">
//         Your details will remain confidential and used only for enquiry purposes.
//       </p>
//     </form>
//   );
// };

// /* -------------------- MAIN PAGE ----------------------- */
// const LogSphere = () => {
//   const [isLoading, setIsLoading] = useState(true);
//   const [showScroll, setShowScroll] = useState(false);
//   const [scrollProgress, setScrollProgress] = useState(0);

//   // 🔁 Ref for hero video
//   const heroVideoRef = useRef(null);

//   // Image load -> hide loading screen
//   useEffect(() => {
//     imagesLoaded(
//       document.querySelectorAll('.content__item-img'),
//       { background: true },
//       () => {
//         document.body.classList.remove('loading');
//         setIsLoading(false);
//       }
//     );
//   }, []);

//   // Parallax scroll for cards
//   useEffect(() => {
//     const items = document.querySelectorAll('.content__item');

//     const handleScroll = () => {
//       items.forEach((item) => {
//         const img = item.querySelector('.content__item-img');
//         const wrapper = img?.parentNode;
//         if (!img || !wrapper) return;

//         const rect = item.getBoundingClientRect();
//         const progress = Math.min(
//           Math.max((window.innerHeight - rect.top) / (window.innerHeight + rect.height), 0),
//           1
//         );

//         const translateY = progress * 100 - 50;
//         const rotate = progress * -45;

//         img.style.transform = `translateY(${translateY}px)`;
//         wrapper.style.transform = `rotate3d(1, 0.3, 0.1, ${rotate}deg)`;
//       });
//     };

//     window.addEventListener('scroll', handleScroll);
//     handleScroll();
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   // Optional: show/hide the arrow scrollToTopBtn like other pages
//   useEffect(() => {
//     const btn = document.querySelector('.scrollToTopBtn');
//     const toggle = () => btn?.classList.toggle('showBtn', window.scrollY > 600);
//     window.addEventListener('scroll', toggle);
//     return () => window.removeEventListener('scroll', toggle);
//   }, []);

//   // Circular scroll progress button visibility & progress
//   useEffect(() => {
//     const circumference = 307.919;
//     const handleProgress = () => {
//       const scrollTop = window.scrollY || document.documentElement.scrollTop;
//       const docHeight = document.documentElement.scrollHeight - window.innerHeight;
//       const progress = docHeight > 0 ? Math.min(Math.max(scrollTop / docHeight, 0), 1) : 0;
//       setScrollProgress(circumference * progress);
//       setShowScroll(scrollTop > 600);
//     };

//     window.addEventListener('scroll', handleProgress);
//     handleProgress();
//     return () => window.removeEventListener('scroll', handleProgress);
//   }, []);

//   // 🔁 Restart hero video when user scrolls back to the top
//   useEffect(() => {
//     let wasNotAtTop = false;

//     const handleVideoReset = () => {
//       const scrollTop = window.scrollY || document.documentElement.scrollTop;
//       const isAtTop = scrollTop < 50;

//       // Only reset when transitioning from not-top → top
//       if (isAtTop && wasNotAtTop && heroVideoRef.current) {
//         heroVideoRef.current.currentTime = 0;
//         heroVideoRef.current.play().catch(() => {});
//       }

//       wasNotAtTop = !isAtTop;
//     };

//     window.addEventListener('scroll', handleVideoReset);
//     handleVideoReset(); // initial check

//     return () => window.removeEventListener('scroll', handleVideoReset);
//   }, []);

//   const scrollToTop = () => {
//     window.scrollTo({ top: 0, behavior: 'smooth' });

//     // also restart video when using the scroll-to-top button
//     if (heroVideoRef.current) {
//       heroVideoRef.current.currentTime = 0;
//       heroVideoRef.current.play().catch(() => {});
//     }
//   };

//   return (
//     <>
//       <Helmet>
//         <title>Streamlined Recruitment &amp; Onboarding Platform | LogSphere</title>
//         <meta
//           name="description"
//           content="LogSphere simplifies recruitment and onboarding with job postings, candidate screening, live assessments, interviews, offers and workflows in one intelligent platform."
//         />
//       </Helmet>

//       {/* Loading Screen */}
//       <div
//         className={`fixed inset-0 bg-black flex items-center justify-center z-50 transition-opacity duration-1000 ${
//           isLoading ? 'opacity-100' : 'opacity-0 pointer-events-none'
//         }`}
//       >
//         <h1 className="text-4xl md:text-6xl font-bold text-white animate-pulse text-center px-4">
//           LogSphere Recruitment &amp; Onboarding
//         </h1>
//       </div>

//       {/* Navbar */}
//       <Navbar />

//       {/* Hero Video Section */}
//       <section className="relative h-screen">
//         <video
//           ref={heroVideoRef}
//           className="absolute inset-0 w-full h-full object-cover"
//           autoPlay
//           loop
//           muted
//           playsInline
//         >
//           <source src="/video/Hi Sphere .mp4" type="video/mp4" />
//         </video>
//         <div className="absolute inset-0 bg-black/60" />
//       </section>

//       {/* Main Content with Parallax */}
//       <main className="bg-black text-white">
//         <div className="content content--padded">
//           {/* Key Modules Section */}
//           <section className="py-12 max-w-5xl mx-auto text-left px-6">
//             <h2 className="text-3xl md:text-4xl font-extrabold mb-6">
//               Key Modules of LogSphere
//             </h2>

//             {/* Job Posting & Candidate Sourcing */}
//             <div className="mb-8">
//               <h3 className="text-2xl md:text-3xl font-bold mb-3">
//                 Job Posting &amp; Candidate Sourcing
//               </h3>
//               <p className="text-base md:text-lg">
//                 Create job openings or internship opportunities and share across multiple portals. Receive
//                 applications directly in the platform for structured evaluation.
//               </p>
//             </div>

//             {/* Candidate Screening & Shortlisting */}
//             <div className="mb-8">
//               <h3 className="text-2xl md:text-3xl font-bold mb-3">
//                 Candidate Screening &amp; Shortlisting
//               </h3>
//               <p className="text-base md:text-lg">
//                 Filter candidates based on skills, experience, qualifications, or assessment results. Rank and
//                 shortlist candidates efficiently.
//               </p>
//             </div>

//             {/* Live Assessment & Coding Tests */}
//             <div className="mb-8">
//               <h3 className="text-2xl md:text-3xl font-bold mb-3">
//                 Live Assessment &amp; Coding Tests
//               </h3>
//               <p className="text-base md:text-lg">
//                 Conduct live coding challenges, MCQs, or skill-based tests in a single session. Evaluate
//                 candidates instantly and fairly.
//               </p>
//             </div>

//             {/* Interview Scheduling & Collaboration */}
//             <div className="mb-8">
//               <h3 className="text-2xl md:text-3xl font-bold mb-3">
//                 Interview Scheduling &amp; Collaboration
//               </h3>
//               <p className="text-base md:text-lg">
//                 Schedule interviews with automated calendar integration. Notify interviewers and candidates via
//                 email or messaging.
//               </p>
//             </div>

//             {/* Offer Management & Onboarding */}
//             <div className="mb-8">
//               <h3 className="text-2xl md:text-3xl font-bold mb-3">
//                 Offer Management &amp; Onboarding
//               </h3>
//               <p className="text-base md:text-lg">
//                 Generate offer letters, collect digital acceptance, and guide candidates through the onboarding
//                 checklist.
//               </p>
//             </div>

//             {/* Employee Data & Compliance Vault */}
//             <div className="mb-8">
//               <h3 className="text-2xl md:text-3xl font-bold mb-3">
//                 Employee Data &amp; Compliance Vault
//               </h3>
//               <p className="text-base md:text-lg">
//                 Securely store candidate and employee records, assessments, and approvals in a centralised vault
//                 for easy access and compliance.
//               </p>
//             </div>

//             {/* Reports & Analytics */}
//             <div className="mb-2">
//               <h3 className="text-2xl md:text-3xl font-bold mb-3">
//                 Reports &amp; Analytics
//               </h3>
//               <p className="text-base md:text-lg">
//                 Generate recruitment pipeline reports, assessment summaries, onboarding status, and completion
//                 metrics to drive smarter hiring decisions.
//               </p>
//             </div>
//           </section>

//           {/* Parallax Cards – LogSphere visuals */}
//           <div
//             className="content__item content__item--expand"
//             style={{ ['--aspect-ratio']: '7/5' }}
//           >
//             <div className="content__item-imgwrap">
//               <div
//                 className="content__item-img"
//                 style={{ backgroundImage: "url('/img/logsphere-jobs.jpg')" }}
//               />
//             </div>
//             <h2 className="content__item-title">Unified Job Management</h2>
//             <p className="content__item-description">
//               Publish roles, track applications and collaborate with hiring managers from one unified workspace.
//             </p>
//           </div>

//           <div
//             className="content__item content__item--expand"
//             style={{ ['--aspect-ratio']: '7/5' }}
//           >
//             <div className="content__item-imgwrap">
//               <div
//                 className="content__item-img"
//                 style={{ backgroundImage: "url('/img/logsphere-assessments.jpg')" }}
//               />
//             </div>
//             <h2 className="content__item-title">Assessments That Scale</h2>
//             <p className="content__item-description">
//               Run coding tests, quizzes and role-based challenges with instant evaluation and result dashboards.
//             </p>
//           </div>

//           <div
//             className="content__item content__item--expand"
//             style={{ ['--aspect-ratio']: '7/5' }}
//           >
//             <div className="content__item-imgwrap">
//               <div
//                 className="content__item-img"
//                 style={{ backgroundImage: "url('/img/logsphere-interviews.jpg')" }}
//               />
//             </div>
//             <h2 className="content__item-title">Collaborative Interviewing</h2>
//             <p className="content__item-description">
//               Coordinate interview panels, share feedback and move candidates through stages without email chaos.
//             </p>
//           </div>

//           <div
//             className="content__item content__item--expand"
//             style={{ ['--aspect-ratio']: '7/5' }}
//           >
//             <div className="content__item-imgwrap">
//               <div
//                 className="content__item-img"
//                 style={{ backgroundImage: "url('/img/logsphere-onboarding.jpg')" }}
//               />
//             </div>
//             <h2 className="content__item-title">Frictionless Onboarding</h2>
//             <p className="content__item-description">
//               Automate checklists, documentation and approvals so new hires are productive from day one.
//             </p>
//           </div>

//           {/* CTA */}
//           <section className="text-center py-32">
//             <h2 className="text-4xl md:text-7xl font-bold mb-6">
//               Start Intelligent Onboarding Today
//             </h2>
//             <p className="text-base md:text-xl text-white/80 max-w-3xl mx-auto mb-8">
//               Bring structure, automation and clarity to every stage of hiring and onboarding with LogSphere.
//             </p>
//             <div className="space-x-8">
//               <Link
//                 to="/contact-us"
//                 className="inline-block bg-blue-600 text-white px-10 py-5 rounded-full text-2xl font-bold hover:bg-blue-700 transition transform hover:scale-110"
//               >
//                 Talk to Experts
//               </Link>
//             </div>
//           </section>

//           {/* Contact section */}
//           <section id="contact" className="py-16 bg-gradient-to-b from-black to-gray-900">
//             <div className="max-w-6xl mx-auto px-6">
//               <h3 className="text-3xl md:text-4xl font-extrabold text-center mb-6">
//                 Tell Us About Your Hiring Needs
//               </h3>
//               <p className="text-center text-white/70 mb-8">
//                 Whether you manage campus drives, bulk hiring, or senior leadership recruitment, our team can
//                 help you tailor LogSphere to your workflows.
//               </p>

//               <ContactForm />
//             </div>
//           </section>
//         </div>
//       </main>

//       {/* Footer */}
//       <Footer />

//       {/* Scroll to Top Button (arrow) */}
//       <button
//         onClick={scrollToTop}
//         className="scrollToTopBtn fixed bottom-10 right-10 z-50 opacity-0 transition-all duration-700"
//       >
//         <svg className="w-16 h-16 text-white drop-shadow-2xl" viewBox="0 0 512 512">
//           <path fill="currentColor" d="M256 108L109 296l37 37 90-90v210h48V243l90 90 37-37z" />
//         </svg>
//       </button>

//       {/* Circular Scroll Progress Button */}
//       {showScroll && (
//         <div
//           onClick={scrollToTop}
//           className="scroll-top fixed bottom-6 right-6 z-50 cursor-pointer flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-r from-blue-500 to-blue-700 shadow-lg hover:from-blue-600 hover:to-blue-800 transition-all"
//         >
//           <svg className="progress-circle -rotate-90 w-12 h-12 absolute" viewBox="-1 -1 102 102">
//             <path
//               d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
//               fill="none"
//               stroke="white"
//               strokeWidth="4"
//               strokeDasharray="307.919"
//               strokeDashoffset={307.919 - scrollProgress}
//               style={{ transition: 'stroke-dashoffset 0.1s linear' }}
//             />
//           </svg>
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             className="w-6 h-6 text-white relative z-10"
//             fill="none"
//             viewBox="0 0 24 24"
//             stroke="currentColor"
//             strokeWidth={2}
//           >
//             <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
//           </svg>
//         </div>
//       )}
//     </>
//   );
// };

// export default LogSphere;








import React, { useState, useEffect, useCallback, useRef } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Flag from 'react-country-flag'; // npm install react-country-flag

const API_URL = 'https://api.securxperts.com:8000';
const ENDPOINT = '/forms/contact';

/* -------------------- ENHANCED HISPHERE CONTACT FORM ----------------------- */
const ContactForm = () => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    country_code: '',
    phoneno: '',
    location: '',
    purpose: '',
    message: '',
  });

  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [isCountryOpen, setIsCountryOpen] = useState(false);
  const [countrySearch, setCountrySearch] = useState('');
  const dropdownRef = useRef(null);

  // Input filters
  const nameFilter = useCallback((value) => /^[A-Za-z\s]*$/.test(value) ? value.slice(0, 50) : form.name, [form.name]);
  const phoneFilter = useCallback((value) => /^\d*$/.test(value) ? value.slice(0, 15) : form.phoneno, [form.phoneno]);

  // COUNTRIES WITH FLAGS
  const countries = [
    { code: '+91', iso: 'IN', name: 'India' },
    { code: '+1', iso: 'US', name: 'United States' },
    { code: '+44', iso: 'GB', name: 'United Kingdom' },
    { code: '+971', iso: 'AE', name: 'United Arab Emirates' },
    { code: '+61', iso: 'AU', name: 'Australia' },
    { code: '+852', iso: 'HK', name: 'Hong Kong' },
    { code: '+36', iso: 'HU', name: 'Hungary' },
    { code: '+354', iso: 'IS', name: 'Iceland' },
    { code: '+93', iso: 'AF', name: 'Afghanistan' },
    { code: '+355', iso: 'AL', name: 'Albania' },
  ];

  const filteredCountries = countries.filter(country =>
    country.name.toLowerCase().includes(countrySearch.toLowerCase()) ||
    country.code.toLowerCase().includes(countrySearch.toLowerCase())
  );

  const validateField = (name, value) => {
    switch (name) {
      case 'name':
        if (!value.trim()) return 'Name is required';
        if (!/^[A-Za-z\s]+$/.test(value)) return 'Only letters and spaces allowed';
        if (value.length < 2) return 'Name must be at least 2 characters';
        return '';

      case 'email':
        if (!value.trim()) return 'Email is required';
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return 'Enter valid email format';
        return '';

      case 'country_code':
        if (!value.trim()) return 'Country code is required';
        if (!countries.some(c => c.code === value)) return 'Select valid country code from dropdown';
        return '';

      case 'phoneno':
  if (!value.trim()) return 'Phone number is required';
  if (!/^\d+$/.test(value)) return 'Only digits allowed';
  if (value.length !== 10) return 'Phone must be exactly 10 digits';
  return '';


      case 'location':
  if (!value.trim()) return 'Location is required';
  if (!/^[A-Za-z\s,.-]+$/.test(value)) return 'Only letters, spaces, commas, periods, hyphens, dots allowed';
  return '';


      case 'purpose':
        if (!value.trim()) return 'Purpose is required';
        return '';

      case 'message':
        if (!value.trim()) return 'Message is required';
        if (value.trim().length < 10) return 'Message must be at least 10 characters';
        return '';

      default:
        return '';
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let filteredValue = value;

    // Apply filters
    switch (name) {
      case 'name': filteredValue = nameFilter(value); break;
      case 'phoneno': filteredValue = phoneFilter(value); break;
    }

    setForm(prev => ({ ...prev, [name]: filteredValue }));
    const errorMsg = validateField(name, filteredValue);
    setErrors(prev => ({ ...prev, [name]: errorMsg }));
  };

  // Country selection
  const selectCountry = (code) => {
    setForm(prev => ({ ...prev, country_code: code }));
    setIsCountryOpen(false);
    setCountrySearch('');
    setErrors(prev => ({ ...prev, country_code: '' }));
  };

  // Outside click handler
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsCountryOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const validateAll = () => {
    const newErrors = {};
    Object.keys(form).forEach(key => {
      newErrors[key] = validateField(key, form[key]);
    });
    setErrors(newErrors);
    return Object.values(newErrors).every(err => err === '');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateAll()) return;

    setSubmitting(true);
    try {
      const payload = { ...form };
      const resp = await fetch(`${API_URL}${ENDPOINT}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (resp.ok) {
        setShowSuccessPopup(true);
        setForm({
          name: '', email: '', country_code: '', phoneno: '',
          location: '', purpose: '', message: '',
        });
        setErrors({});
      } else {
        console.error('Submit failed:', resp.status);
      }
    } catch (error) {
      console.error('Network error:', error);
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    if (showSuccessPopup) {
      const timer = setTimeout(() => setShowSuccessPopup(false), 5000);
      return () => clearTimeout(timer);
    }
  }, [showSuccessPopup]);

  // SUCCESS POPUP (HRMS STYLE)
  if (showSuccessPopup) {
    return (
      <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-xl max-w-xs w-full shadow-2xl relative p-4 animate-in fade-in zoom-in duration-200">
          <button
            onClick={() => setShowSuccessPopup(false)}
            className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-xl font-bold p-1 hover:bg-gray-100 rounded-full transition-all w-8 h-8 flex items-center justify-center"
          >
            ×
          </button>
          <div className="text-center pt-2">
            <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3">
              <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-1">Success!</h3>
            <p className="text-gray-600 text-sm">Your HiSphere request has been submitted successfully.</p>
          </div>
        </div>
      </div>
    );
  }

  const hasAnyError = Object.values(errors).some(e => e);

  return (
    <form onSubmit={handleSubmit} className="max-w-3xl mx-auto bg-white p-6 md:p-10 rounded-2xl shadow-xl border border-gray-200">
      <h3 className="text-2xl md:text-3xl font-bold text-center mb-8 text-[#0a1e42]">
        Request a Trial or Live Demo
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {[
          { name: 'name', placeholder: 'Full Name *', span: 1 },
          { name: 'email', type: 'email', placeholder: 'Email *', span: 1 },
          
          // COUNTRY DROPDOWN
          { name: 'country_code', placeholder: 'Country Code *', span: 1, isDropdown: true },
          
          { name: 'phoneno', placeholder: 'Phone Number *', span: 1 },
          { name: 'location', placeholder: 'Location (City, Country) *', span: 2 },
          { name: 'purpose', placeholder: 'Purpose (Demo/Partnership/Implementation) *', span: 2 },
          { name: 'message', type: 'textarea', placeholder: 'Tell us briefly about your requirement *', span: 2 },
        ].map((field) => (
          <div key={field.name} className={field.span === 2 ? 'md:col-span-2' : ''}>
            {field.isDropdown ? (
              // COUNTRY DROPDOWN WITH FLAGS
              <div className="relative" ref={dropdownRef}>
                <button
                  type="button"
                  onClick={() => setIsCountryOpen(!isCountryOpen)}
                  className={`w-full px-4 py-3 rounded-lg border-2 border-gray-300 bg-white text-gray-900 placeholder-gray-500 text-left flex justify-between items-center hover:border-gray-400 focus:outline-none focus:border-[#0a1e42] focus:ring-1 focus:ring-[#0a1e42]/30 transition-all pr-10 ${
                    errors.country_code ? 'border-orange-400 ring-2 ring-orange-200' : ''
                  }`}
                >
                  <span className="flex items-center gap-2 truncate flex-1">
                    {form.country_code ? (
                      <>
                        <Flag 
                          countryCode={countries.find(c => c.code === form.country_code)?.iso} 
                          svg className="w-5 h-3.5 flex-shrink-0 rounded" 
                        />
                        <span className="font-medium text-sm truncate">
                          {countries.find(c => c.code === form.country_code)?.name}
                        </span>
                        <span className="text-xs font-mono text-gray-500 ml-1">
                          {form.country_code}
                        </span>
                      </>
                    ) : (
                      <span className="text-gray-500 text-sm">Select Country Code</span>
                    )}
                  </span>
                  <svg className={`w-5 h-5 transition-transform text-gray-500 ${isCountryOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                {errors.country_code && (
                  <p className="mt-1 text-xs text-orange-400 font-medium pl-2">{errors.country_code}</p>
                )}

                {isCountryOpen && (
                  <div className="absolute z-50 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-2xl max-h-80 overflow-hidden">
                    <input
                      type="text"
                      value={countrySearch}
                      onChange={(e) => setCountrySearch(e.target.value)}
                      placeholder="Search country or code..."
                      className="w-full px-4 py-3 border-b border-gray-100 text-sm focus:outline-none focus:ring-1 focus:ring-[#0a1e42]"
                      autoFocus
                    />
                    <div className="max-h-64 overflow-auto">
                      {filteredCountries.length > 0 ? (
                        filteredCountries.map((country) => (
                          <button
                            key={country.code}
                            type="button"
                            onClick={() => selectCountry(country.code)}
                            className="w-full px-4 py-3 text-left hover:bg-gray-50 transition-all flex items-center gap-3 text-sm first:pt-2 last:pb-2 focus:outline-none focus:bg-gray-100"
                          >
                            <Flag countryCode={country.iso} svg className="w-6 h-4 flex-shrink-0 rounded" />
                            <span className="font-medium flex-1 min-w-0 truncate pr-4">{country.name}</span>
                            <span className="text-xs font-mono text-gray-600 bg-gray-100 px-2 py-1 rounded-full">
                              {country.code}
                            </span>
                          </button>
                        ))
                      ) : (
                        <div className="px-4 py-8 text-center text-sm text-gray-500">No countries found</div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            ) : (
              // REGULAR INPUT / TEXTAREA
              <>
                {field.type === 'textarea' ? (
                  <textarea
                    name={field.name}
                    value={form[field.name]}
                    onChange={handleChange}
                    rows={4}
                    placeholder={field.placeholder}
                    required
                    className={`w-full p-3 rounded-lg border-2 border-gray-300 bg-white text-gray-900 placeholder-gray-500 resize-none focus:outline-none focus:border-[#0a1e42] focus:ring-1 focus:ring-[#0a1e42]/30 transition-all duration-200 ${
                      errors[field.name] ? 'border-orange-400 ring-2 ring-orange-200' : ''
                    }`}
                  />
                ) : (
                  <input
                    name={field.name}
                    type={field.type || 'text'}
                    value={form[field.name]}
                    onChange={handleChange}
                    placeholder={field.placeholder}
                    required
                    className={`w-full p-3 rounded-lg border-2 border-gray-300 bg-white text-gray-900 placeholder-gray-500 focus:outline-none focus:border-[#0a1e42] focus:ring-1 focus:ring-[#0a1e42]/30 transition-all duration-200 ${
                      errors[field.name] ? 'border-orange-400 ring-2 ring-orange-200' : ''
                    }`}
                  />
                )}
                {errors[field.name] && (
                  <p className="mt-1 text-xs text-orange-400 font-medium pl-2">{errors[field.name]}</p>
                )}
              </>
            )}
          </div>
        ))}
      </div>

      <button
        type="submit"
        disabled={submitting || hasAnyError}
        className="bg-[#0a1e42] hover:bg-[#081533] disabled:bg-gray-400 disabled:cursor-not-allowed text-white py-3 rounded-xl font-semibold mt-8 shadow-md transition-all duration-300 text-lg w-full"
      >
        {submitting ? 'Submitting...' : 'Submit Request'}
      </button>
    </form>
  );
};

export default function Hishpare() {
  return (
    <div className="w-full font-sans text-[#0a1e42] overflow-hidden mb-24">
 <div className="fixed top-0 left-0 w-full z-[9999]">
  <Navbar />
</div>

      
      {/* =========================================================
         HERO SECTION
      ========================================================== */}
       <section className="w-full bg-white pt-4 pb-10 px-6 md:px-20 flex flex-col md:flex-row items-center gap-10">
        <div className="md:w-1/2">
          <img src="/img/212.png" alt="Logo" className="w-32 mb-28 ml-4" />

          <h1 className="text-4xl md:text-5xl font-bold leading-snug ">
           Next-Gen Recruitment & Onboarding System
          </h1>

          <p className="mt-4 text-gray-600 max-w-md mb-24">
          HiSphere streamlines recruitment and onboarding, centralising hiring workflows for a fast, automated process.
          </p>
        </div>

        <div className="md:w-1/2 mt-24">
          <img
            src="/img/hisphereheroimg.png"
            alt="Hero"
            className="w-full rounded-2xl shadow-lg"
          />
        </div>
      </section>

      {/* =========================================================
         VIDEO SECTION
      ========================================================== */}
      <section className="w-full py-20 px-6 md:px-0 bg-gray-50">
        <div className="max-w-7xl mx-auto">
                   <div className="max-w-3xl mx-auto mb-10 text-center">
    <h2 className="text-3xl font-bold text-[#063852]">
            Hi-Sphere in Action
            </h2>
            <p className="text-gray-600 mt-3">
             Discover how Hi-Sphere transforms hiring and onboarding into a smooth, seamless process.An AI-powered platform that makes hiring and onboarding simple, fast, and organised.

            </p>
            </div>
          <div className="relative rounded-2xl md:rounded-3xl overflow-hidden shadow-2xl group">
            <video
              className="w-full block"
              src="/video/hisphere .mp4"
              muted
              playsInline
              autoPlay
              loop
              preload="auto"
              controls={false}
              key="lauratek-video"
              onClick={(e) => {
                const video = e.currentTarget;
                video.paused ? video.play() : video.pause();
              }}
            >
              Your browser does not support HTML5 video.
            </video>

            <div className="absolute bottom-6 right-6 md:bottom-8 md:right-8 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  const video = e.currentTarget.closest('div').querySelector('video');
                  if (video.requestFullscreen) video.requestFullscreen();
                  else if (video.webkitRequestFullscreen) video.webkitRequestFullscreen();
                  else if (video.mozRequestFullScreen) video.mozRequestFullScreen();
                  else if (video.msRequestFullscreen) video.msRequestFullscreen();
                }}
                className="bg-black/70 hover:bg-black/90 text-white p-4 rounded-xl backdrop-blur-md transition transform hover:scale-110 shadow-2xl"
                title="Fullscreen"
              >
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                    d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5v-4m0 4h-4m4-4l-5-5" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* =========================================================
         BEYOND THE RESUME
      ========================================================== */}
      <section className="w-full py-24 px-6 md:px-20">
        <h2 className="text-4xl font-extrabold text-center mb-4">
         Intelligent Workforce & Device Monitoring Platform
        </h2>

        <p className="text-center text-gray-600 max-w-2xl mx-auto mb-14">
          HiSphere enables real-time monitoring of workforce activity, app usage, and system events across devices, providing actionable insights, secure data management and GDPR-compliant analytics to boost productivity and operational efficiency.
        </p>

        <div className="grid md:grid-cols-3 gap-12 max-w-6xl mx-auto">
          {/* Feature 1 */}
          <div className="text-center">
            <img src="/img/efficienthiring.png" className="w-16 mx-auto mb-4" />
            <h3 className="text-xl font-bold mb-2">Efficient Hiring Workflows</h3>
            <p className="text-gray-600 text-sm">
              Automate job postings, candidate shortlisting and interview scheduling to save time and reduce administrative effort.
            </p>
          </div>

          {/* Feature 2 */}
          <div className="text-center">
            <img src="/img/seamlessonboarding.png" className="w-16 mx-auto mb-4" />
            <h3 className="text-xl font-bold mb-2">Seamless Onboarding</h3>
            <p className="text-gray-600 text-sm">
               Guide new hires through structured onboarding checklists and digital documentation for a smooth and organised start.
            </p>
          </div>

          {/* Feature 3 */}
          <div className="text-center">
            <img src="/img/candidateexperience.png" className="w-16 mx-auto mb-4" />
            <h3 className="text-xl font-bold mb-2">Enhanced Candidate Experience</h3>
            <p className="text-gray-600 text-sm">
              Deliver a professional, transparent and speedy recruitment process that attracts and retains top talent.
            </p>
          </div>
        </div>
      </section>

      {/* =========================================================
         PERSONALIZED SERVICES
      ========================================================== */}
      <section className="w-full py-24 px-6 md:px-20 bg-white">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* LEFT GRAPHIC */}
          <div>
            <img
              src="/img/hiimg1.png"
              className="rounded-2xl shadow-2xl w-full"
            />
          </div>

          {/* RIGHT TEXT BLOCK */}
          <div>
            <h2 className="text-4xl font-extrabold mb-6">
             Seamless Talent Acquisition & Onboarding Platform
            </h2>

            <div className="space-y-8">
              <div>
                <h3 className="text-xl font-bold mb-1">Automated Hiring Workflows</h3>
                <p className="text-gray-600 text-sm">
                   Manage job postings, candidate screening and interview scheduling in one platform to save time and reduce manual effort.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-bold mb-1">Smooth Onboarding Process</h3>
                <p className="text-gray-600 text-sm">
                   Guide new hires with digital offer letters, structured onboarding checklists and clear role readiness tasks.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-bold mb-1">Enhanced Candidate Experience</h3>
                <p className="text-gray-600 text-sm">
                   Deliver a fast, transparent and professional recruitment process that keeps top talent engaged.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-bold mb-1">Save time</h3>
                <p className="text-gray-600 text-sm">
                   Track recruitment metrics, monitor hiring performance and use data-driven insights to improve HR strategies.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =========================================================
         KEY FEATURES SECTION
      ========================================================== */}
      <section className="w-full py-24 px-6 md:px-20 bg-[#f7f9ff]">
        <div className="max-w-5xl mx-auto bg-white rounded-2xl shadow-xl p-12">
          <h2 className="text-3xl font-bold mb-10">Key Modules of LogSphere</h2>

          <div className="grid md:grid-cols-2 gap-12">
            {/* Feature 1 */}
            <div className="flex gap-4">
              <img src="/img/jobposting.png" className="w-12 h-12" />
              <div>
                <h3 className="font-semibold text-lg">Job Posting & Talent Sourcing</h3>
                <p className="text-gray-600 text-sm">
                   Create job openings or internship opportunities, share across multiple portals and receive applications directly in LogSphere for structured evaluation.
                </p>
              </div>
            </div>

            {/* Feature 2 */}
            <div className="flex gap-4">
              <img src="/img/candidatescreening (2).png" className="w-12 h-12" />
              <div>
                <h3 className="font-semibold text-lg">Candidate Screening & Shortlisting</h3>
                <p className="text-gray-600 text-sm">
                   Filter applicants based on skills, experience and qualifications, and rank candidates efficiently for the next stage.
                </p>
              </div>
            </div>
           <div className="flex gap-4">
              <img src="/img/liveassessments.png" className="w-12 h-12" />
              <div>
                <h3 className="font-semibold text-lg">Live Assessments & Skill Tests</h3>
                <p className="text-gray-600 text-sm">
                   Conduct live coding challenges, MCQs or skill-based tests in a single session with instant evaluation for fair comparison.
                </p>
              </div>
            </div>
           <div className="flex gap-4">
              <img src="/img/interviewscheduling (1).png" className="w-12 h-12" />
              <div>
                <h3 className="font-semibold text-lg">Candidate Screening & Shortlisting</h3>
                <p className="text-gray-600 text-sm">
                   Filter applicants based on skills, experience and qualifications, and rank candidates efficiently for the next stage.
                </p>
              </div>
            </div>
          </div>

          {/* Resume Score Card */}
         
{/* <div className="mt-14 bg-[#eef4ff] p-8 rounded-2xl border">
    <h3 className="font-bold text-xl mb-4">AI Resume Score</h3>
    <p className="text-gray-600 text-sm mb-6 max-w-md">
      Upload your resume and instantly receive actionable insights.
    </p>
    <img src="/img/resumeimg (1).png" className="w-full rounded-xl" />
  </div> */}
        </div>
      </section>
      
      <ContactForm />
      <Footer />
    </div>
  );
}